import { Grid } from '@mui/material';
import React from 'react'
import { formatDate } from '../../utilities/formatters';
import HeadAndDesc from "../ReusableComponents/HeadAndDesc"
import Title from '../ReusableComponents/title';

const StatFormatter = (data) => {
    const Stat = data && data.toLowerCase()
    const classList =
        Stat === "resolved"
            ? "StatusResolved"
            : Stat === "dismissed"
                ? "StatusDismissed"
                : "StatusProgress"

    return <div className={`${classList}`}>{data}</div>
}

const CaseDetails = (props) => {
    return (
      <div>
        <Title six>
          Case ID - {props.data && props.data.id && props.data.id}
        </Title>
        <Grid
          xs={12}
          sm={12}
          md={7}
          lg={7}
          xl={5}
          className="CaseDetailsBox Container-p-20 mtt-20"
        >
          <Title six>Case Details</Title>
          <div className="mtt-10">
            <Grid container>
              <Grid xs={6} sm={6} md={4}>
                <HeadAndDesc
                  HeadTitle="Subject"
                  SubTitle={
                    props.data && props.data.subject && props.data.subject
                  }
                />
                <HeadAndDesc
                  HeadTitle="Case ID"
                  SubTitle={props.data && props.data.id && props.data.id}
                  onClick="onClick"
                />
                <HeadAndDesc
                  HeadTitle="Created"
                  SubTitle={
                    props.data &&
                    props.data.created &&
                    formatDate(props.data.created)
                  }
                />
                <HeadAndDesc
                  HeadTitle="Opened by"
                  SubTitle={
                    props.data && props.data.User_id.id && props.data.User_id.id
                  }
                />
                 <HeadAndDesc
                  HeadTitle="Comment"
                  SubTitle={
                    props.data && props.data.comment && props.data.comment
                  }
                />
              </Grid>
              <Grid xs={6} sm={6} md={4}>
                <HeadAndDesc
                  HeadTitle="Case Type"
                  SubTitle={
                    props.data && props.data.Case_Type && props.data.Case_Type
                  }
                />
                <HeadAndDesc
                  HeadTitle="Severity"
                  SubTitle={
                    props.data && props.data.severity && props.data.severity
                  }
                />
                <HeadAndDesc
                  HeadTitle="Category"
                  SubTitle={
                    props.data && props.data.category && props.data.category
                  }
                />
                <HeadAndDesc HeadTitle="Additional contacts" SubTitle={"-"} />
              </Grid>
              <Grid xs={6} sm={6} md={4}>
                <HeadAndDesc
                  HeadTitle="Status"
                  SubTitle={StatFormatter(
                    props.data && props.data.status && props.data.status
                  )}
                />
                <HeadAndDesc
                  HeadTitle="Response"
                  SubTitle={
                    props.data && props.data.comment && props.data.comment
                  }
                />
                <HeadAndDesc
                  HeadTitle="attachment"
                  SubTitle={
                    props.data && props.data.attachment && props.data.attachment
                      ? props.data.attachment
                      : "-"
                  }
                  SubTitleClass="attachment"
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
      </div>
    );
}

export default CaseDetails;